import axios, { AxiosRequestConfig } from 'axios';

const URL = '/v2/hidden-jobs/';

class HiddenJobService {
  static hide(
    sitterId: number,
    jobId: number,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    return axios.post(URL, { sitter: { id: sitterId }, job: { id: jobId } }, config);
  }

  static unhide(
    sitterId: number,
    jobId: number,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    return axios.delete(URL, { ...config, params: { sitterId, jobId } });
  }
}

export { HiddenJobService };
